import React, { useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';

import PardotForm from './PardotForm';
// import { WavelyticsQuiz } from '../ProductFeature/wavelyticsQuiz';
import { WavelyticsQuiz } from '../ProductFeature/WavelyticsQuiz';

const useStyles = makeStyles((theme) => ({
  contact: {},
  header: {
    textAlign: 'center',
    marginBottom: '1rem',
    width: '998px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  fullWidthHeader: {
    textAlign: 'center',
    marginBottom: '1rem',
    width: '998px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '80vw',
    },
  },
  nonModalBackground: {
    maxWidth: '100%',
    // width: '1000px',
    backgroundColor: '#fff',
    borderRadius: '20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    border: '1px solid #E5EAF4',
    padding: '20px',
    position: 'relative',
    zIndex: 4,
    lineHeight: '0',
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      margin: '0 24px',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '0 16px',
      padding: '20px 0px',
    },
  },
  slideUpBackground: {
    maxWidth: '100%',
    // width: '1000px',
    backgroundColor: '#fff',
    borderRadius: '20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    border: '1px solid #E5EAF4',
    padding: '20px',
    position: 'relative',
    zIndex: 4,
    lineHeight: '0',
    overflowY: 'auto',
    marginTop: '-200px',
    [theme.breakpoints.down('md')]: {
      marginTop: '-145px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '-145px 24px 0',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '-110px 16px 0',
      padding: '20px 0px',
    },
  },
  form: {},
  formImagesItem: {},
  quizLogo: {
    margin: '2rem 2rem 2rem 4rem',
    [theme.breakpoints.down('md')]: {
      margin: '1rem 1rem 1rem 2rem',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '1rem',
      maxWidth: '70%',
    },
  },
}));

export const ContactForm = ({
  contactForm,
  modal,
  noForm,
  formImages,
  pardotUrl,
  pricingDesktop,
  fullWidthForm = false,
  slideUp,
  wavelytics,
  quizIntro,
  quizLogo,
}) => {
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [quizStarted, setQuizStarted] = useState(false);
  const { header = 'Find the TEAM Software solution for you!', body = '' } =
    contactForm || {};

  const classes = useStyles();

  return (
    <div
      style={{
        display: noForm ? 'none' : pricingDesktop ? 'flex' : 'block',
        justifyContent: pricingDesktop ? 'center' : 'flex-start',
        width: wavelytics && '100%',
      }}
    >
      {!modal && (
        <div
          className={
            slideUp ? classes.slideUpBackground : classes.nonModalBackground
          }
        >
          {body && (
            <Grid item className={classes.subText}>
              <Typography
                variant='body1'
                className={classes.subText}
                style={{ color: 'white' }}
              >
                {body}
              </Typography>
            </Grid>
          )}

          <Grid container justifyContent='flex-start'>
            {quizLogo ? (
              <GatsbyImage
                image={quizLogo.asset.gatsbyImageData}
                className={classes.quizLogo}
                alt='Wavelytics Logo'
              />
            ) : null}
          </Grid>
          {!wavelytics ? (
            <div>
              {!!formImages ? (
                <Grid item className={classes.formImagesItem}>
                  {formImages.map((formImage) => (
                    <a href={formImage.link} target='_blank' rel='noreferrer'>
                      <GatsbyImage
                        image={formImage.image?.asset?.gatsbyImageData}
                        alt=''
                        style={{ margin: '0 1.25rem' }}
                      />
                    </a>
                  ))}
                </Grid>
              ) : null}
              {header && (
                <Grid container justifyContent='center' alignItems='center'>
                  <Grid item>
                    <Typography
                      variant='h2'
                      color='primary'
                      className={
                        fullWidthForm ? classes.fullWidthHeader : classes.header
                      }
                    >
                      {header}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </div>
          ) : null}

          {!wavelytics ? (
            <div style={{ padding: '0rem 1rem' }}>
              <PardotForm url={pardotUrl} />
            </div>
          ) : null}

          {wavelytics ? (
            <WavelyticsQuiz
              setQuizCompleted={setQuizCompleted}
              quizStarted={quizStarted}
              setQuizStarted={setQuizStarted}
              quizIntro={quizIntro}
              pardotUrl={pardotUrl}
              quizCompleted={quizCompleted}
            />
          ) : null}
        </div>
      )}
      {modal && (
        <>
          {body && (
            <Grid item className={classes.subText}>
              <Typography
                variant='body1'
                className={classes.subText}
                style={{ color: '#002D5C' }}
              >
                {body}
              </Typography>
            </Grid>
          )}

          <div>
            {!!formImages ? (
              <Grid item className={classes.formImagesItem}>
                {formImages.map((formImage) => (
                  <a href={formImage.link} target='_blank' rel='noreferrer'>
                    <GatsbyImage
                      image={formImage.image?.asset?.gatsbyImageData}
                      alt=''
                      style={{ margin: '0 1.25rem' }}
                    />
                  </a>
                ))}
              </Grid>
            ) : null}
            {header && (
              <Grid container justifyContent='center'>
                <Grid item xs={10}>
                  <Typography
                    variant='h2'
                    color='primary'
                    className={classes.header}
                  >
                    {header}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>

          {quizCompleted || !wavelytics ? <PardotForm url={pardotUrl} /> : null}
          {/* {wavelytics && !quizCompleted ? <WavelyticsQuiz /> : null} */}
        </>
      )}
    </div>
  );
};
